module.exports = __webpack_public_path__ + "img/i10-logo.6641a875.png";